export default "__VITE_ASSET__xnm1tVAh__"